import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Input from 'react-toolbox/lib/input'

import styles from './DateInput.scss'

class DateInput extends React.Component {
  isValid(formattedValue) {
    let { value } = this.props
    let errorText = ''
    if (value) {
      const noPrefix = value.slice(2)
      const isMatch = value.match(/^[0-9\/]*$/)

      if (!isMatch || isNaN(Date.parse(formattedValue)))
        errorText = 'Invalid Date'
    }

    return errorText
  }

  formatDate() {
    const { value } = this.props
    let formattedText = ''

    if (value) {
      let datePair = this.splitPair(value)
      let length = datePair.length - 1
      formattedText =  datePair.map(
        (date,index) => {
          if (index === length)
            return date
          else
            return date + '/'}
      ).join('')
    }

    return formattedText
  }

  getDateInteger(text){
    let date = text.replace(/\//g, '')
    if (date.length < 7) return date
  }

  splitPair(text){
    return text.split('').reduce((result, value, index, array) => {
      if (index % 2 === 0 )
        result.push(array.slice(index, index + 2).join(''))
      return result
    }, [])
  }

  onChange = (value) => {
    const { onChange } = this.props
    const dateInt = this.getDateInteger(value)
    if (dateInt !== undefined && onChange) onChange(dateInt)
  }

  render() {
    let { label, error, disabled } = this.props
    const value = this.formatDate()
    error = error ? error : this.isValid(value)

    return (
      <Input
        disabled={disabled}
        theme={styles}
        label={label}
        value={value}
        error={error}
        onChange={this.onChange}
      />
    )
  }
}

export default DateInput
